/* Dummy data for ProjectPlan */
const tabs = [
  {
    name: 'Trip info', route: 'design.project_plan', current: false,
  },
  {
    name: 'Program', route: 'design.project_plan.program', current: false,
  },
  {
    name: 'Checklist', route: 'design.project_plan.checklist', current: false,
  },
  {
    name: 'Client dialogue', route: 'design.project_plan.client', current: false,
  },
  {
    name: 'Tour Manager dialogue', route: 'design.project_plan.tour_manager', current: false,
  },
  {
    name: 'Sign-ups', route: 'design.project_plan.signups', current: false,
  },
];

const activity = [
  {
    id: 1,
    type: 'comment',
    person: {
      name: 'Jørgen Ellingsen', href: '#',
    },
    imageUrl:
      'https://images.unsplash.com/photo-1520785643438-5bf77931f493?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=256&h=256&q=80',
    comment:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Tincidunt nunc ipsum tempor purus vitae id. Morbi in vestibulum nec varius. Et diam cursus quis sed purus nam. ',
    date: '6d ago',
  },
  {
    id: 2,
    type: 'assignment',
    person: {
      name: 'Jørgen Ellingsen', href: '#',
    },
    assigned: {
      name: 'Kim Sagbakken', href: '#',
    },
    date: '2d ago',
  },
  {
    id: 3,
    type: 'files',
    person: {
      name: 'Kim Sagbakken', href: '#',
    },
    files: [
      {
        name: 'flight_tickets_group_a.pdf', href: '#',
      },
      {
        name: 'flight_tickets_group_b.pdf', href: '#',
      },
      {
        name: 'flight_tickets_group_c.pdf', href: '#',
      },
      {
        name: 'flight_company_confirmation.pdf', href: '#',
      },
    ],
    date: '6h ago',
  },
  {
    id: 4,
    type: 'comment',
    person: {
      name: 'Simen Eira', href: '#',
    },
    imageUrl:
      'https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=256&h=256&q=80',
    comment:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Tincidunt nunc ipsum tempor purus vitae id. Morbi in vestibulum nec varius. Et diam cursus quis sed purus nam. Scelerisque amet elit non sit ut tincidunt condimentum. Nisl ultrices eu venenatis diam.',
    date: '2h ago',
  },
];

const subtasks = [
  {
    id: 1,
    title: 'Get confirmation from Client',
  },
  {
    id: 2,
    title: 'Get final confirmation from Airline company',
  },
];

const tasks = {
  Flights: [
    {
      id: 1,
      name: 'Oslo → Miami',
      role: 'Tasks regarding this flight',
      icon: 'PaperAirplaneIcon',
      class: 'rotate-90',
      selected: true,
    },
    {
      id: 3,
      name: 'Miami → New York',
      role: 'Tasks regarding this flight',
      icon: 'PaperAirplaneIcon',
      class: 'rotate-90',
      selected: false,
    },
    {
      id: 3,
      name: 'New York → Oslo',
      role: 'Tasks regarding this flight',
      icon: 'PaperAirplaneIcon',
      class: '-rotate-90',
      selected: false,
    },
  ],
  Lodging: [
    {
      id: 4,
      name: 'JW Marriott Miami',
      role: 'Miami Lodging tasks',
      icon: 'HomeIcon',
      class: '',
      selected: false,
    },
    {
      id: 5,
      name: 'Hotel AKA Brickell',
      role: 'Miami Lodging tasks',
      icon: 'HomeIcon',
      class: '',
      selected: false,
    },
    {
      id: 6,
      name: 'The Beekman, a Thompson Hotel',
      role: 'New York Lodging tasks',
      icon: 'HomeIcon',
      class: '',
      selected: false,
    },
    {
      id: 7,
      name: 'DoubleTree by Hilton New York Downtown',
      role: 'New York Lodging tasks',
      icon: 'HomeIcon',
      class: '',
      selected: false,
    },
  ],
  Restaurants: [
    {
      id: 8,
      name: 'LPM Restaurant & Bar',
      role: 'Miami eatery tasks',
      icon: 'BookOpenIcon',
      class: '',
      selected: false,
    },
    {
      id: 9,
      name: 'Moxies Miami Restaurant',
      role: 'Miami eatery tasks',
      icon: 'BookOpenIcon',
      class: '',
      selected: false,
    },
    {
      id: 10,
      name: 'Il Grano Pizzeria & Restaurant',
      role: 'Miami eatery tasks',
      icon: 'BookOpenIcon',
      class: '',
      selected: false,
    },
    {
      id: 11,
      name: 'Brooklyn Chop House Steakhouse Downtown NYC',
      role: 'New York eatery tasks',
      icon: 'BookOpenIcon',
      class: '',
      selected: false,
    },
    {
      id: 12,
      name: 'Le Coucou',
      role: 'New York eatery tasks',
      icon: 'BookOpenIcon',
      class: '',
      selected: false,
    },
  ],
  Other: [
    {
      id: 13,
      name: 'Client invoicing',
      role: 'Tasks regarding client invoicing',
      icon: 'CreditCardIcon',
      class: '',
      selected: false,
    },
    {
      id: 14,
      name: 'Tour Manager invoicing',
      role: 'Tasks regarding tour manager invoicing',
      icon: 'CreditCardIcon',
      class: '',
      selected: false,
    },
  ],
};

const taskAssignees = [
  {
    name: 'Everyone', company: '',
  },
  {
    name: 'Unassigned tasks', company: '',
  },
  {
    name: 'Kim Sagbakken', company: 'Ellera AS',
  },
  {
    name: 'Stig Selås', company: 'Firmatur AS',
  },
];

const project = {
  id: 1,
  client_contact_id: null,
  client_id: 1,
  name: 'Ferie, vinteren 2022',
  status: 'draft',
  comment: null,
  project_manager: 1,
  total_travelers: null,
  budget_per_traveller: null,
  start_date: null,
  end_date: null,
  team_id: 1,
  created_by: 1,
  updated_by: null,
  deleted_by: null,
  deleted_at: null,
  created_at: '2022-11-18T13:15:59.000000Z',
  updated_at: '2022-11-18T13:15:59.000000Z',
  client: {
    id: 1,
    name: 'Ellera AS',
    legal_name: null,
    identifier: null,
    comment: null,
    team_id: 1,
    key_account_manager: 1,
    primary_contact: null,
    created_by: 1,
    updated_by: null,
    deleted_by: null,
    deleted_at: null,
    created_at: '2022-11-18T13:15:51.000000Z',
    updated_at: '2022-11-18T13:15:51.000000Z',
    class: 'App\\Models\\Client',
    contacts: [],
  },
  contact: null,
  activities: [],
  manager: {
    id: 1,
    name: 'Jørgen Ellingsen',
    email: 'jorgen@ellera.no',
    email_verified_at: '2022-01-01T00:00:00.000000Z',
    current_team_id: 1,
    profile_photo_path: null,
    created_at: null,
    updated_at: '2022-11-18T13:12:19.000000Z',
    profile_photo_url: 'https://ui-avatars.com/api/?name=J+E&color=7F9CF5&background=EBF4FF',
    role: {
      id: 3,
      team_id: null,
      name: 'owner',
      guard_name: 'web',
      created_at: '2022-11-18T13:12:15.000000Z',
      updated_at: '2022-11-18T13:12:15.000000Z',
      pivot: {
        model_id: 1,
        role_id: 3,
        model_type: 'App\\Models\\User',
      },
    },
  },
};

const proposal = {
  id: 4,
  client_id: 4,
  title: 'Miami til New York',
  subtitle: 'Flott tur langs østkysten',
  notes: null,
  media_id: 22,
  teaser_title: 'Flott tur til Miami og NY',
  teaser_description: 'Vi byr på mange gode middager og drinker',
  teaser_media_id: 23,
  currency_id: 'NOK',
  pax: 6,
  amount_pr_pax: 9000,
  status: 'draft',
  start_date: '2022-12-08',
  end_date: '2022-12-11',
  project_id: 5,
  created_by: 2,
  updated_by: null,
  deleted_by: null,
  deleted_at: null,
  created_at: '2022-11-23T11:27:51.000000Z',
  updated_at: '2022-11-23T11:40:10.000000Z',
  client: {
    id: 4,
    name: 'Firmatur AS',
    legal_name: null,
    identifier: null,
    comment: null,
    team_id: 1,
    key_account_manager: 1,
    primary_contact: null,
    created_by: 2,
    updated_by: null,
    deleted_by: null,
    deleted_at: null,
    created_at: '2022-11-23T11:20:48.000000Z',
    updated_at: '2022-11-23T11:20:48.000000Z',
    class: 'App\\Models\\Client',
  },
  project: {
    id: 5,
    client_contact_id: null,
    client_id: 4,
    name: 'Tur til USA',
    status: 'draft',
    comment: null,
    project_manager: 2,
    total_travelers: null,
    budget_per_traveller: null,
    start_date: null,
    end_date: null,
    team_id: 1,
    created_by: 2,
    updated_by: null,
    deleted_by: null,
    deleted_at: null,
    created_at: '2022-11-23T11:21:06.000000Z',
    updated_at: '2022-11-23T11:21:06.000000Z',
    team: {
      id: 1,
      user_id: 1,
      name: 'Ellera',
      email: null,
      photo_path: null,
      created_at: '2022-11-18T13:12:18.000000Z',
      updated_at: '2022-11-18T13:12:18.000000Z',
      personal_team: 0,
      photo_url: 'https://ui-avatars.com/api/?name=Ellera&color=FFFFFF&background=25383C',
      isOperator: true,
      isGuide: true,
      operator: {
        id: 1,
        team_id: 1,
        created_at: '2022-11-18T13:12:19.000000Z',
        updated_at: '2022-11-18T13:12:19.000000Z',
      },
      guide: {
        id: 1,
        team_id: 1,
        created_at: '2022-11-18T13:12:19.000000Z',
        updated_at: '2022-11-18T13:12:19.000000Z',
      },
    },
  },
  places: [
    {
      id: 737,
      name: 'Miami',
      area: 'Florida, United States',
      place_id: 'ChIJEcHIDqKw2YgRZU-t3XHylv8',
      slug: 'miami-florida-united-states',
      parent_id: 237,
      type: 'destination',
      img: null,
      location: {
        type: 'Point',
        coordinates: [
          -80.1917902,
          25.7616798,
        ],
      },
      viewport_north_east: {
        type: 'Point',
        coordinates: [
          -80.139157044341,
          25.85577296341,
        ],
      },
      viewport_south_west: {
        type: 'Point',
        coordinates: [
          -80.31975991553,
          25.709041953134,
        ],
      },
      created_at: '2022-11-23T11:27:39.000000Z',
      updated_at: '2022-11-23T11:27:39.000000Z',
      database: true,
      image: '/img/flags/us.svg',
      pivot: {
        proposal_id: 4,
        place_id: 737,
        id: 5,
        heading: 'Opplev de beste restaurantene i Florida',
        description: 'En ekte matsafari i 2 dager',
      },
      parent: {
        id: 237,
        name: 'United States',
        area: 'North America',
        place_id: 'ChIJCzYy5IS16lQRQrfeQ5K5Oxw',
        slug: 'united-states-north-america',
        parent_id: 5,
        type: 'country',
        img: '/flags/us.svg',
        location: {
          type: 'Point',
          coordinates: [
            37.09024,
            -95.712891,
          ],
        },
        viewport_north_east: {
          type: 'Point',
          coordinates: [
            49.38,
            -66.94,
          ],
        },
        viewport_south_west: {
          type: 'Point',
          coordinates: [
            25.82,
            -124.39,
          ],
        },
        created_at: '2022-11-09T07:38:16.000000Z',
        updated_at: '2022-11-09T07:38:16.000000Z',
        database: true,
        image: '/img/flags/us.svg',
      },
    },
    {
      id: 511,
      name: 'New York',
      area: 'New York, United States',
      place_id: 'ChIJOwg_06VPwokRYv534QaPC8g',
      slug: 'new-york-new-york-united-states',
      parent_id: 237,
      type: 'destination',
      img: '',
      location: {
        type: 'Point',
        coordinates: [
          -74.0059728,
          40.7127753,
        ],
      },
      viewport_north_east: {
        type: 'Point',
        coordinates: [
          -73.700272068176,
          40.917577050708,
        ],
      },
      viewport_south_west: {
        type: 'Point',
        coordinates: [
          -74.259089914279,
          40.477399060455,
        ],
      },
      created_at: '2022-11-09T12:26:07.000000Z',
      updated_at: '2022-11-09T12:26:07.000000Z',
      database: true,
      image: '/img/flags/us.svg',
      pivot: {
        proposal_id: 4,
        place_id: 511,
        id: 6,
        heading: 'Welcome to The Apple',
        description: 'New York er et av verdens viktigste økonomiske og kulturelle knutepunkter, og byen har en lang rekke kjente museer, teatre, gallerier, mediehus, internasjonale selskaper og børs­institusjoner. New York huser alle internasjonale delegasjoner til De forente nasjoner, og organisasjonens hovedkvarter ligger også her.',
      },
      parent: {
        id: 237,
        name: 'United States',
        area: 'North America',
        place_id: 'ChIJCzYy5IS16lQRQrfeQ5K5Oxw',
        slug: 'united-states-north-america',
        parent_id: 5,
        type: 'country',
        img: '/flags/us.svg',
        location: {
          type: 'Point',
          coordinates: [
            37.09024,
            -95.712891,
          ],
        },
        viewport_north_east: {
          type: 'Point',
          coordinates: [
            49.38,
            -66.94,
          ],
        },
        viewport_south_west: {
          type: 'Point',
          coordinates: [
            25.82,
            -124.39,
          ],
        },
        created_at: '2022-11-09T07:38:16.000000Z',
        updated_at: '2022-11-09T07:38:16.000000Z',
        database: true,
        image: '/img/flags/us.svg',
      },
    },
  ],
  gallery: [
    {
      id: 23,
      model_type: 'App\\Models\\Team',
      model_id: 1,
      uuid: 'bb3640d1-2506-4a34-9bdf-0f4b28707e47',
      collection_name: 'team',
      name: 'pexels-nextvoyage-2225499.jpg',
      file_name: '1669203608_pexels-nextvoyage-2225499.jpg',
      mime_type: 'image/jpeg',
      disk: 'digitalocean',
      conversions_disk: 'digitalocean',
      size: 3395753,
      manipulations: [],
      custom_properties: [],
      generated_conversions: [],
      responsive_images: [],
      order_column: 23,
      created_at: '2022-11-23T11:40:08.000000Z',
      updated_at: '2022-11-23T11:40:08.000000Z',
      created_by: 1,
      updated_by: null,
      original_url: 'https://traveloffice-beta.ams3.digitaloceanspaces.com/23/1669203608_pexels-nextvoyage-2225499.jpg',
      preview_url: '',
      pivot: {
        proposal_id: 4,
        media_id: 23,
      },
      creator: {
        id: 1,
        name: 'Jørgen Ellingsen',
        email: 'jorgen@ellera.no',
        email_verified_at: '2022-01-01T00:00:00.000000Z',
        current_team_id: 1,
        profile_photo_path: null,
        created_at: null,
        updated_at: '2022-11-18T13:12:19.000000Z',
        profile_photo_url: 'https://ui-avatars.com/api/?name=J+E&color=7F9CF5&background=EBF4FF',
        role: {
          id: 3,
          team_id: null,
          name: 'owner',
          guard_name: 'web',
          created_at: '2022-11-18T13:12:15.000000Z',
          updated_at: '2022-11-18T13:12:15.000000Z',
          pivot: {
            model_id: 1,
            role_id: 3,
            model_type: 'App\\Models\\User',
          },
        },
      },
      editor: null,
    },
  ],
  creator: {
    id: 2,
    name: 'Simen Eira',
    email: 'simen@ellera.no',
    email_verified_at: '2022-01-01T00:00:00.000000Z',
    current_team_id: 1,
    profile_photo_path: null,
    created_at: null,
    updated_at: '2022-11-18T13:12:19.000000Z',
    profile_photo_url: 'https://ui-avatars.com/api/?name=S+E&color=7F9CF5&background=EBF4FF',
    role: {
      id: 4,
      team_id: null,
      name: 'manager',
      guard_name: 'web',
      created_at: '2022-11-18T13:12:16.000000Z',
      updated_at: '2022-11-18T13:12:16.000000Z',
      pivot: {
        model_id: 2,
        role_id: 4,
        model_type: 'App\\Models\\User',
      },
    },
  },
  image: {
    id: 22,
    model_type: 'App\\Models\\Team',
    model_id: 1,
    uuid: '22ac819e-53e0-43eb-aee8-593633f0f6d7',
    collection_name: 'team',
    name: 'pexels-elvis-vasquez-421655.jpg',
    file_name: '1669202917_pexels-elvis-vasquez-421655.jpg',
    mime_type: 'image/jpeg',
    disk: 'digitalocean',
    conversions_disk: 'digitalocean',
    size: 1262923,
    manipulations: [],
    custom_properties: [],
    generated_conversions: [],
    responsive_images: [],
    order_column: 22,
    created_at: '2022-11-23T11:28:38.000000Z',
    updated_at: '2022-11-23T11:28:38.000000Z',
    created_by: 1,
    updated_by: null,
    original_url: 'https://traveloffice-beta.ams3.digitaloceanspaces.com/22/1669202917_pexels-elvis-vasquez-421655.jpg',
    preview_url: '',
    creator: {
      id: 1,
      name: 'Jørgen Ellingsen',
      email: 'jorgen@ellera.no',
      email_verified_at: '2022-01-01T00:00:00.000000Z',
      current_team_id: 1,
      profile_photo_path: null,
      created_at: null,
      updated_at: '2022-11-18T13:12:19.000000Z',
      profile_photo_url: 'https://ui-avatars.com/api/?name=J+E&color=7F9CF5&background=EBF4FF',
      role: {
        id: 3,
        team_id: null,
        name: 'owner',
        guard_name: 'web',
        created_at: '2022-11-18T13:12:15.000000Z',
        updated_at: '2022-11-18T13:12:15.000000Z',
        pivot: {
          model_id: 1,
          role_id: 3,
          model_type: 'App\\Models\\User',
        },
      },
    },
    editor: null,
  },
  teaser_image: {
    id: 23,
    model_type: 'App\\Models\\Team',
    model_id: 1,
    uuid: 'bb3640d1-2506-4a34-9bdf-0f4b28707e47',
    collection_name: 'team',
    name: 'pexels-nextvoyage-2225499.jpg',
    file_name: '1669203608_pexels-nextvoyage-2225499.jpg',
    mime_type: 'image/jpeg',
    disk: 'digitalocean',
    conversions_disk: 'digitalocean',
    size: 3395753,
    manipulations: [],
    custom_properties: [],
    generated_conversions: [],
    responsive_images: [],
    order_column: 23,
    created_at: '2022-11-23T11:40:08.000000Z',
    updated_at: '2022-11-23T11:40:08.000000Z',
    created_by: 1,
    updated_by: null,
    original_url: 'https://traveloffice-beta.ams3.digitaloceanspaces.com/23/1669203608_pexels-nextvoyage-2225499.jpg',
    preview_url: '',
    creator: {
      id: 1,
      name: 'Jørgen Ellingsen',
      email: 'jorgen@ellera.no',
      email_verified_at: '2022-01-01T00:00:00.000000Z',
      current_team_id: 1,
      profile_photo_path: null,
      created_at: null,
      updated_at: '2022-11-18T13:12:19.000000Z',
      profile_photo_url: 'https://ui-avatars.com/api/?name=J+E&color=7F9CF5&background=EBF4FF',
      role: {
        id: 3,
        team_id: null,
        name: 'owner',
        guard_name: 'web',
        created_at: '2022-11-18T13:12:15.000000Z',
        updated_at: '2022-11-18T13:12:15.000000Z',
        pivot: {
          model_id: 1,
          role_id: 3,
          model_type: 'App\\Models\\User',
        },
      },
    },
    editor: null,
  },
};

export {
  tabs,
  subtasks,
  activity,
  tasks,
  project,
  proposal,
  taskAssignees,
};
